import { render } from "./DashboardSale.vue?vue&type=template&id=571f18e9&scoped=true&ts=true&lang=pug"
import script from "./DashboardSale.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardSale.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardSale.vue?vue&type=style&index=0&id=571f18e9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571f18e9"]])

export default __exports__